
import React from 'react';
import { ArrowUpRight, ArrowDownRight } from 'lucide-react';
import { cn } from '@/lib/utils';
import { formatPercentage, isProfitPositive } from './utils/formatting';
import { useTranslation } from 'react-i18next';
import { useIsMobile } from '@/hooks/use-mobile';

interface ProfitStatsSectionProps {
  potentialProfit?: string;
  maxDrawdown?: string;
}

export const ProfitStatsSection = ({
  potentialProfit,
  maxDrawdown
}: ProfitStatsSectionProps) => {
  const { t } = useTranslation();
  const isMobile = useIsMobile();
  
  return (
    <div className={`px-4 md:px-6 py-2 bg-black/20 backdrop-blur-sm rounded-md mx-4 md:mx-6 mb-2`}>
      <div className="grid grid-cols-2 gap-2 md:gap-4 text-center">
        <div className="flex flex-col items-center">
          <div className={`${isMobile ? "text-[10px]" : "text-xs"} text-muted-foreground mb-1`}>{t('potential_profit')}</div>
          <div className={cn(
            `${isMobile ? "text-base" : "text-xl"} font-bold flex items-center`,
            isProfitPositive(potentialProfit) ? "text-green-500" : "text-red-500"
          )}>
            <ArrowUpRight className={`${isMobile ? "h-4 w-4" : "h-5 w-5"} mr-0.5 md:mr-1`} />
            {formatPercentage(potentialProfit)}
          </div>
        </div>
        
        <div className="flex flex-col items-center">
          <div className={`${isMobile ? "text-[10px]" : "text-xs"} text-muted-foreground mb-1`}>{t('max_drawdown')}</div>
          <div className={`${isMobile ? "text-base" : "text-xl"} font-bold flex items-center text-red-500`}>
            <ArrowDownRight className={`${isMobile ? "h-4 w-4" : "h-5 w-5"} mr-0.5 md:mr-1`} />
            {formatPercentage(maxDrawdown, true)}
          </div>
        </div>
      </div>
    </div>
  );
};
